import apiClient from '@u/apiClient'
import EnaosEligibleFuneralHomesController from '@/wayfinder/actions/App/Http/Controllers/FuneralHomePartner/Enaos/EnaosEligibleFuneralHomesController'
import EnaosGetSalesExportByAgenceController from '@/wayfinder/actions/App/Http/Controllers/FuneralHomePartner/Enaos/EnaosGetSalesExportByAgenceController'
import EnaosGetInfoDossierForOrderController from '@/wayfinder/actions/App/Http/Controllers/FuneralHomePartner/Enaos/EnaosGetInfoDossierForOrderController'
import EnaosCreateSupplierOrderFromSalesExportController from '@/wayfinder/actions/App/Http/Controllers/FuneralHomePartner/Enaos/EnaosCreateSupplierOrderFromSalesExportController'
import EnaosCreateInvoiceFromSalesExportController from '@/wayfinder/actions/App/Http/Controllers/FuneralHomePartner/Enaos/EnaosCreateInvoiceFromSalesExportController'

export default {
  enaosEligibleFuneralHomes({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(EnaosEligibleFuneralHomesController.get())
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  getSalesExportByFuneralHome({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          EnaosGetSalesExportByAgenceController.get({
            funeral_home: payload.funeral_home_id
          }),
          {
            params: payload.params
          }
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  getSalesExportInfoDossier({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          EnaosGetInfoDossierForOrderController.get({
            funeral_home: payload.funeral_home_id
          }),
          {
            params: payload.params
          }
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  storeNewSupplierOrderForEnaosItem({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          EnaosCreateSupplierOrderFromSalesExportController.post({
            funeral_home: payload.funeral_home_id
          }),
          payload.params
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  storeNewInvoiceForEnaosItemFromFuneralHome({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          EnaosCreateInvoiceFromSalesExportController.post({
            funeral_home: payload.funeral_home_id
          }),
          payload.params
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          console.error('Erreur storeNewInvoiceForEnaosItem:', error)
          reject(error)
        })
    })
  }
}
